import script from "./log.vue?vue&type=script&lang=js&setup=true"
export * from "./log.vue?vue&type=script&lang=js&setup=true"

import "./log.vue?vue&type=style&index=0&id=9c191dc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c191dc6"]])

export default __exports__